import { pipe } from 'ramda';

import {
  buildCmsUrl,
  CMSApiBase,
  CMSArrayBase,
  CMSImageBase,
  getResponseCMS,
} from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';
import { isCMSV3 } from '@/helpers/conf';

export interface Method extends CMSArrayBase {
  name: string;
  type: string;
  fee: string;
  processingTime: string;
  limitsPerTransaction: string; // HTML
  image: CMSImageBase;
  imageGrayscale: CMSImageBase;
  registrationForm: boolean;
  lobbySlider: boolean;
  paymentMethodsPage: boolean;
}

export enum MethodGroupType {
  DEPOSIT = 'deposit',
  WITHDRAW = 'withdraw',
}

export interface MethodGroup extends CMSArrayBase {
  title: string;
  type: MethodGroupType;
  methods: Method[];
}

export interface PaymentMethodsApi extends CMSApiBase {
  title: string;
  titleH1: string;
  text: string;
  methodsGroups: MethodGroup[];
}

export const paymentMethodsCMSV3 = (lang: string) =>
  request<PaymentMethodsApi>({
    url: buildCmsUrl({ path: 'payment-methods', lang }),
  });

export const paymentMethodsCMSV4 = (lang: string) =>
  request<PaymentMethodsApi>({
    url: buildCmsUrl({
      path: 'payment-method',
      lang,
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<PaymentMethodsApi>
    ),
  });

export const paymentMethodsCMS = isCMSV3
  ? paymentMethodsCMSV3
  : paymentMethodsCMSV4;
